<template>
  <div class="home">
    <!-- Header -->
    <header class="header">
      <div class="logo-list">
        <div class="logo"></div>
        <div class="logo-text">HaoXin</div>
      </div>

      <!-- <ul class="nav">
        <li>Home</li>
        <li>Products</li>
        <li>About</li>
        <li>Service</li>
        <li>Contact</li>
      </ul> -->

      <div class="icon icon-whatsapp" @click="contactMe(whatsappUrl)"></div>
    </header>

    <!-- Banner -->
    <section class="banner">
      <div class="banner-content">
        <h1>Professional Manufacturer</h1>

        <p>High Quality Products With Competitive Price.</p>

        <!-- <button>Explore Products</button> -->
      </div>
    </section>

    <!-- Category -->
    <section class="category section">
      <h2>Product Categories</h2>

      <div class="category-list">
        <div
          class="category-item"
          v-for="item in categories"
          :key="item.id"
          @click="seeDetail(item.id)"
        >
          <img :src="item.image" />
          <div class="item-name">{{ item.name }}</div>
        </div>
      </div>
    </section>

    <!-- Products -->
    <!-- <section class="products section">
      <h2>Featured Products</h2>

      <div class="product-list">
        <div class="product-card" v-for="item in products" :key="item.id">
          <img :src="item.image" />

          <h3>{{ item.name }}</h3>

          <p>{{ item.desc }}</p>

          <button>View Details</button>
        </div>
      </div>
    </section> -->

    <!-- Advantage -->
    <section class="advantage">
      <h2>Why Choose Us</h2>

      <div class="advantage-list">
        <div class="advantage-item">
          <h3>10+ Years</h3>
          <p>Manufacturing Experience</p>
        </div>

        <div class="advantage-item">
          <h3>OEM & ODM</h3>
          <p>Customized Solution</p>
        </div>

        <div class="advantage-item">
          <h3>Fast Delivery</h3>
          <p>Global Shipping</p>
        </div>

        <div class="advantage-item">
          <h3>24/7</h3>
          <p>Customer Support</p>
        </div>
      </div>
    </section>

    <!-- About -->
    <section class="about section">
      <div class="about-left"></div>

      <div class="about-right">
        <h2>About Company</h2>

        <p>
          We are a professional manufacturer focusing on high-quality products
          and global export business. Our products are exported to Europe,
          America, Southeast Asia and more than 80 countries.
        </p>

        <!-- <button>Learn More</button> -->
      </div>
    </section>

    <!-- Contact -->
    <section class="contact">
      <h2>Contact Us</h2>
      <div class="wechat-contact">
        <img src="../../public/wechat.jpg" alt="" />
      </div>
      <div class="icon-list">
        <div class="icon icon-whatsapp" @click="contactMe(whatsappUrl)"></div>
        <div class="icon icon-facebook" @click="contactMe(facebookUrl)"></div>
        <div class="icon icon-tiktok" @click="contactMe(tiktokUrl)"></div>
        <div class="icon icon-instagram" @click="contactMe(instagramUrl)"></div>
      </div>
    </section>

    <!-- Footer -->
    <footer class="footer">©2026 HaoXin COMPANY All Rights Reserved.</footer>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",

  data() {
    return {
      whatsappUrl: "https://wa.me/8613265700149/",
      facebookUrl: "https://www.facebook.com/share/1EPWp4P2Mg/?mibextid=wwXIfr",
      tiktokUrl:
        "https://www.tiktok.com/@luojiajiapromaxsems?_r=1&_t=ZG-98Wijg98bY1",
      instagramUrl:
        "https://www.instagram.com/luojiajiapromaxsems?igsh=MWNqcWI4NGkxd2pqdA%3D%3D&utm_source=qr",
      categories: [
        {
          id: "5kwh",
          name: "5KWH battery",
          image: require("../../public/prodPImg/pro5kwh/1.jpg"),
        },
        {
          id: "10kwh",
          name: "10KWH battery",
          image: require("../../public/prodPImg/pro10kwh/1.jpg"),
        },
        {
          id: "16kwh",
          name: "16KWH battery",
          image: require("../../public/prodPImg/pro16kwh/1.jpg"),
        },
        {
          id: "kh1200",
          name: "KH-1200",
          image: require("../../public/prodPImg/prokh1200/1.jpg"),
        },
        {
          id: "kh5000",
          name: "KH-5000",
          image: require("../../public/prodPImg/prokh5000/1.jpg"),
        },
        {
          id: "yy",
          name: "YY-series",
          image: require("../../public/prodPImg/proyy/1.jpg"),
        },
                {
          id: "12+32kwh",
          name: "12+32KWH",
          image: require("../../public/prodPImg/pro12+32kwh/1.jpg"),
        },
      ],

      // products: [
      //   {
      //     id: '5kwh',
      //     name: "Product A",
      //     desc: "High Quality Product",
      //     image: "https://picsum.photos/350/300?5",
      //   },
      //   {
      //     id: 2,
      //     name: "Product B",
      //     desc: "Professional Factory",
      //     image: "https://picsum.photos/350/300?6",
      //   },
      //   {
      //     id: 3,
      //     name: "Product C",
      //     desc: "OEM Supported",
      //     image: "https://picsum.photos/350/300?7",
      //   },
      //   {
      //     id: 4,
      //     name: "Product D",
      //     desc: "Global Shipping",
      //     image: "https://picsum.photos/350/300?8",
      //   },
      // ],
    };
  },
  methods: {
    contactMe(url) {
      window.open(url, "_blank");
    },
    seeDetail(id) {
      this.$router
        .push({
          path: "/productDetail",
          query: {
            id: id,
          },
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: Arial;
}

.header {
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 80px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.wechat-contact {
  padding: 10px;
}
.wechat-contact img {
  width: 150px;
  height: 150px;
}
.icon {
  margin-right: 5px;
  margin-left: 5px;
  width: 40px;
  height: 40px;
  background-size: contain;
  background-repeat: no-repeat;
  cursor: pointer;
}
.icon-list {
  display: flex;
  justify-content: center;
}
.icon-whatsapp {
  background-image: url("../../public/svg/whatsapp.svg");
}
.icon-facebook {
  background-image: url("../../public/svg/Facebook.svg");
}
.icon-tiktok {
  background-image: url("../../public/svg/tiktoklogo_tiktok.svg");
}
.icon-instagram {
  background-image: url("../../public/svg/instagram.svg");
}
.logo-list {
  display: flex;
  justify-content: center;
}
.logo-text {
  height: 70px;
  display: flex;
  align-items: center;
  font-size: 28px;
  font-weight: bold;
}

.logo {
  background-size: contain;
  background-repeat: no-repeat;
  height: 70px;
  width: 70px;
  background-image: url("../../public/HaoXinlogo.png");
}

.nav {
  display: flex;
  list-style: none;
}

.nav li {
  margin: 0 25px;
  cursor: pointer;
}

.quote-btn {
  background: #0056ff;
  color: #fff;
  border: none;
  padding: 12px 30px;
  border-radius: 6px;
}

.banner {
  height: 600px;
  background: url("../../public/HOME.png");
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

.banner-content {
  width: 600px;
  margin-left: 100px;
  color: #fff;
}

.banner h1 {
  font-size: 60px;
}

.banner p {
  margin: 25px 0;
  line-height: 30px;
}

.banner button {
  background: #ff6b00;
  color: #fff;
  border: none;
  padding: 15px 35px;
}

.section {
  padding: 80px;
}

.section h2 {
  text-align: center;
  margin-bottom: 50px;
}

.category-list,
.product-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
}

.product-card:hover {
  box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.3);
}

.category-item,
.product-card {
  text-align: center;
  background: #fff;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
}

.category-item:hover {
  box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.3);
}

.category-item img {
  width: 100%;
  height: 85%;
}
.product-card img {
  width: 100%;
  height: 75%;
}
.category-item img {
  pointer-events: none;
}
.category-item .item-name {
  display: flex;
  height: 15%;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.product-card h3 {
  margin: 20px 0;
}

.product-card p {
  padding: 0 20px;
}

.product-card button {
  margin-top: 20px;
  padding: 10px 25px;
}

.advantage {
  background: #0056ff;
  color: #fff;
  padding: 80px;
}

.advantage h2 {
  text-align: center;
  margin-bottom: 50px;
}

.advantage-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
}

.advantage-item {
  text-align: center;
}

.about {
  display: flex;
  align-items: center;
  gap: 60px;
}
.about-left {
  height: 400px;
  background: url("../../public/fact.png");
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.about-left,
.about-right {
  flex: 1;
}

.about img {
  width: 100%;
}

.about button {
  margin-top: 30px;
  padding: 12px 30px;
}

.contact {
  padding: 30px;
  background: #f5f5f5;
}

.contact h2 {
  text-align: center;
  margin-bottom: 0px;
}

.contact-box {
  width: 700px;
  margin: auto;
  display: flex;
  flex-direction: column;
}

.contact-box input,
.contact-box textarea {
  margin-bottom: 20px;
  padding: 15px;
}

.contact-box textarea {
  height: 150px;
}

.contact-box button {
  padding: 15px;
  background: #0056ff;
  color: #fff;
  border: none;
}

.footer {
  text-align: center;
  padding: 30px;
  background: #222;
  color: #fff;
}

@media (max-width: 768px) {
  .header {
    padding: 20px;
  }

  .nav {
    display: none;
  }

  .category-list,
  .product-list,
  .advantage-list {
    grid-template-columns: 1fr;
  }

  .about {
    flex-direction: column;
  }

  .contact-box {
    width: 100%;
  }
  .banner {
    height: 300px;
  }
  .banner-content {
    margin: 20px;
  }

  .banner h1 {
    font-size: 36px;
  }
}
</style>
